import { render, staticRenderFns } from "./ToggleIconButton.vue?vue&type=template&id=567384dc&scoped=true&"
import script from "./ToggleIconButton.vue?vue&type=script&lang=js&"
export * from "./ToggleIconButton.vue?vue&type=script&lang=js&"
import style0 from "./ToggleIconButton.vue?vue&type=style&index=0&id=567384dc&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567384dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567384dc')) {
      api.createRecord('567384dc', component.options)
    } else {
      api.reload('567384dc', component.options)
    }
    module.hot.accept("./ToggleIconButton.vue?vue&type=template&id=567384dc&scoped=true&", function () {
      api.rerender('567384dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/ToggleIconButton.vue"
export default component.exports